import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { optionalUrlParams } from 'utils/common';
import {
  collectionTotalNumberOfItemsSelector,
  collectionCurrentPageSelector,
  viewRangeSelector,
  isCollectionLoadingSelector,
  collectionSelector,
} from 'common/selectors/index';
import { getVideosPerPageSelector } from 'common/selectors/index';
import { Pagination } from 'components/pagination/index';
import { Sorting } from 'components/sorting/index';
import { urlVideoIdSelector } from 'pages/channel.page/index';
import { urlSortSelector } from 'common/selectors/router';
import { VideoListLoader } from 'components/video-list-loader';

const Component = withRouter(
  connect(
    (state, props) => ({
      collectionTotalCount: collectionTotalNumberOfItemsSelector(state),
      itemsPerPage: getVideosPerPageSelector(state),
      currentPageNum: collectionCurrentPageSelector(state),
      videoId: urlVideoIdSelector(state, props.match),
      sort: urlSortSelector(state, props.match),
      viewRange: viewRangeSelector(state),
      isLoading: isCollectionLoadingSelector(state),
      collection: collectionSelector(state),
    }),
    (dispatch) => ({ dispatch })
  )((props) => {
    const pagination = props.collectionTotalCount ? (
      <div className="ct-desktop-collection__pagination">
        <Pagination
          link={`${props.baseUrl}/#page#/${props.videoId ? props.videoId : ''}${optionalUrlParams({
            sort: props.sort,
          })}`}
          total={props.collectionTotalCount}
          itemsPerPage={props.itemsPerPage}
          pageNumber={props.currentPageNum}
        />
      </div>
    ) : null;
    return (
      <div className="ct-desktop-collection">
        <div
          className={`ct-desktop-collection__options ct-desktop-collection__options--top${
            props.withSort && props.collectionTotalCount > 0 ? ' ct-desktop-collection__options--with-sort' : ''
          }`}
          data-e2e="pagination-top"
        >
          {props.withSort && props.collectionTotalCount > 0 && (
            <Sorting
              link={`${props.baseUrl}/1/${props.videoId ? props.videoId : ''}`}
              videoId={props.videoId}
              sortBy={props.sortBy}
            />
          )}

          {pagination}
        </div>

        {props.isLoading ? (
          <VideoListLoader
            errorMsg={'channel_no_videos'}
            isLoading={props.isLoading}
            videos={props.collection.videos}
          />
        ) : (
          props.children
        )}

        <div className="ct-desktop-collection__options" data-e2e="pagination-bottom">
          {pagination}
        </div>
      </div>
    );
  })
);

export const DesktopContainer = ({ baseUrl, withSort, sortBy, children }) => (
  <Component baseUrl={baseUrl} withSort={withSort} sortBy={sortBy} children={children} />
);

DesktopContainer.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  withSort: PropTypes.bool.isRequired,
  sortBy: PropTypes.array,
  children: PropTypes.object,
};
